import { Observable } from "rxjs";

export interface Chat {
  name: string;
  settings: any;
  messages?: any;
  privacies?: any;
  notAllowed?: any;
  css?: string;
  uid: string;
  id?: string;
  slug?: string;
  timestamp?: number;
}

export abstract class ChatData {
  abstract createChat(form: Chat);
  abstract getChats(pagination, filter, order);
  abstract getChat(id: string);
  abstract editChat(data: Chat, id: string);
  abstract deleteChat(id: string);
  abstract duplicateChat(id: string);
}
